import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@fiverr-private/layout_components';
import AiSuggestionRow from '../AiSuggestionRow';

const AiPillTypingState = ({ historyIds, gigIds }) => {
    if (!historyIds.length && !gigIds.length) {
        return null;
    }

    return (
        <Container as="ul" display="flex" flexDirection="column" gap="1">
            {historyIds.map((id) => (
                <AiSuggestionRow key={id} id={id} isHistory />
            ))}
            {gigIds.map((id) => (
                <AiSuggestionRow key={id} id={id} />
            ))}
        </Container>
    );
};

AiPillTypingState.propTypes = {
    historyIds: PropTypes.arrayOf(PropTypes.string),
    gigIds: PropTypes.arrayOf(PropTypes.string),
};

AiPillTypingState.defaultProps = {
    historyIds: [],
    gigIds: [],
};

export { AiPillTypingState };
export default AiPillTypingState;
